import Image from 'next/image';

import competitiveExchangeRates from '@/assets/images/competitiveExchangeRates.svg';
import hassleFreeDocs from '@/assets/images/hassleFreeDocs.svg';
import multiCurrencyAccept from '@/assets/images/multiCurrencyAccept.svg';
import secureShield from '@/assets/images/secureShield.svg';

const SellReason = () => {
  return (
    <section className="home__tab">
      <div className="reason-tab-content bg bg--light">
        <div className="tab-pane active container">
          <h2 className="text--black text--bold section__title-small step-text text-center">
            Reasons to Sell Forex to Us
          </h2>
          <div className="row">
            <div className="col-lg">
              <div className="tab__card__container">
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={secureShield}
                      alt="30 minutes door step service"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">100%</span> Secure
                      transactions
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={competitiveExchangeRates}
                      alt="lowest interest rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Competitive</span> exchange
                      rates
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={multiCurrencyAccept}
                      alt="lowest interest rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Multi-currency</span>{' '}
                      acceptable
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={hassleFreeDocs}
                      alt="gold rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Hassle-free</span>{' '}
                      documentation
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SellReason;
